import template from './mapFilterEditPage.html';
import controller from './mapFilterEditPage.controller';
import './mapFilterEditPage.scss';

let mapFilterEditPageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default mapFilterEditPageComponent;
